/* global $ */

const $togglers = $('.js-content-toggler');

const toggle = {
  /**
   * Initialize the toggle module
   * @return {void}
   */
  initialize() {
    if ($togglers.length) {
      this.createEvents();
    }
  },

  /**
   * Create all events for the toggler
   * @return {void}
   */
  createEvents() {
    $togglers.on('click', ({ currentTarget }) => {
      const $toggler = $(currentTarget);
      const isOpen = $toggler.hasClass('is-open');

      this.toggleContent($toggler);
      this.toggleButtonText($toggler, isOpen);
    });
  },

  toggleContent($toggler) {
    const $content = $(`.js-content[data-toggle-element="${$toggler.data('toggle-target')}"]`);
    const isOpen = $content.hasClass('is-open');
    const initialHeight = $content.data('initial-height');
    const height = $content.children().toArray().reduce((prev, item) => (
      prev + $(item).outerHeight(true)
    ), 0);

    $content
      .css('height', isOpen ? initialHeight : height)
      .toggleClass('is-open')
      .attr('aria-expanded', !isOpen);
  },

  toggleButtonText($toggler, state) {
    const expandedText = $toggler.data('toggle-expanded-text');
    const collapsedText = $toggler.data('toggle-collapsed-text');

    $toggler
      .attr('aria-expanded', !state)
      .toggleClass('is-open')
      .find('span')
      .text(!state ? expandedText : collapsedText);
  },
};

export default toggle;
